export function buildWhatsappLink(phone?: string | null, message?: string | null) {
  const sanitized = (phone || "").replace(/\D/g, "");
  if (!sanitized) return "";
  const params = new URLSearchParams();
  params.set("phone", sanitized);
  if (message && message.trim()) {
    params.set("text", message.trim());
  }
  params.set("type", "phone_number");
  params.set("app_absent", "0");
  return `https://api.whatsapp.com/send/?${params.toString()}`;
}
